<span>
    <label *ngIf="name != undefined && name != null && name != ''" for="{{name}}">{{label}}</label>
  <div style="padding-bottom: 6px"> </div>
    <ng-content></ng-content>
</span>
